export default {
  sideMenu: {
    main: "主页",
    home: "首页",
    login: "登录页",
    authority_server:"认证服务",
    authority_management: "权限相关",
    user_management: "成员管理",
    organization_management: "组织管理",
    resource_management: "资源管理",
    role_management: "资源分组",
  },
  common: {
    invalidForm:"表单校验失败",
    invalidPhone: "手机号码格式不正确",
    invalidVerifyCode: "验证码格式不正确",
    onlyone:"新增名称不能重复",
    action:'操作',
    close:"关闭",
    cardType1: "内地身份证",
    cardType2: "香港身份证",
    cardType3: "澳门身份证",
    cardType4: "其他证件/证照",
    name: "姓名",
    ID: "ID",
    email: "邮箱",
    position: "岗位",
    exportMemeber: "导出成员",
    exportResource: "导出资源",
    addOrg: "新增机构",
    orgList: "机构列表",
    place: "地区",
    forbid: "停用",
    normal: "正常",
    cancel: "取消",
    status: "状态",
    selectDate: "选择日期",
    inputKey: "输入ID/名称搜索",
    loginTitle: "商城管理平台",
    pleaseInput: "请输入",
    pleaseSelect: "请选择",
    query: "查询",
    add: "新增",
    edit: "编辑",
    remove: "删除",
    connectResourceGroup: "关联资源分组",
    addOrgorPo: "新增部门或岗位",
    toTop: "置顶",
    exportMember: "导出人员",
    uploadResource: "资源上传",
    resourceExport: "资源导出",
    alert: "警告",
    connectResource: "关联资源",
    remark: "备注",
    confirmEdit: "确认要进行修改吗？",
    myCollection:"我的收藏",
    addtoCollection:"点击添加功能到我的收藏",
    myCollectionSetting:"我的收藏配置",
    notice: "公告",
    currentTime:"当前时间",
    collectedList:"已收藏的功能列表",
    delete:"删除",
    primaryDirectory:"一级目录",
    functionName:"功能名称",
    functionNameQuery:"输入功能名称查询",
    selectGrouptoAdd:"请选择要新增的功能分组",
    maxFunction:"我的收藏最多可以存放N个功能",
    confirm:"确定",
    msg:"消息",
    confirmDelete:"确认要进行删除操作吗，该操作",
    unrecoverable:"不可恢复",
    associatedPhone: "关联手机号",
    unbind: "取消关联",
    queryPhone: "查看手机号",
    addSuccess: "添加成功",
    index: "序号",
    phoneRepeated: "手机号不能重复"
  },
  login: {
    org: "机构号",
    userName: "用户名",
    passwords: "密码",
    login: "登录",
    locked: "已锁定",
    phone: "手机号",
    verifyCode: "验证码",
    getVerifyCode: "发送验证码",
    copyRight: "© 版权所有QCC 版本号：CAKU V1.00",
  },
  timeZone: "8", //时区
  message: {
    hello: "好好学习，天天向上！",
  },
  authorization: {
    addMember: "添加成员",
    editMember: "编辑成员",
    addresource: "添加资源",
    editresource: "编辑资源",
    addresourceGroup: "添加资源组",
    editresourceGroup: "编辑资源组",
    addPhone: "添加手机号",
    member: {
      name: "Name",
      userId: "用户ID",
      userName: "用户姓名",
      userKind: "用户类别",
      userRole: "用户角色",
      lastUpdater: "最后更新者",
      lastUpdateTime: "最后更新时间",
      rootOrgCode: "一级组织机构号",
      parentOrgCode: "父级组织机构号",
      branchCode: "分支行号",
      contactNo: "联系电话",
      email: "电子邮箱",
      positionCodes: "用户岗位",
      loginPwd: "登录密码",
      effectiveDate: "密码生效时间",
      pwdExpDate: "密码过期时间",
      addMemeberTitle: "新增成员",
      editMemeberTitle: "编辑成员",
      addTitle: "新增",
      connectResourceGroup: "关联资源分组",
      onlyChooseOne: "只能选择一项编辑！",
      mustChooseOne: "必须选择一项！",
      loginId: "登录ID",
      ID: "ID",
      job: "岗位",
      basicInfo: "基础信息",
      loginInfo: "登录信息",
      phoneInfo: "手机号信息",
      positionRule: "多个岗位时，用”,”分割。Eg:code1,code2,code3",
      lengthRule: "长度限制16，其他待补充",
      loginPwdRule: "待补充",
      effectiveDateRule: "yyyy-MM-dd HH:mm:ss 不得大于过期时间",
      pwdExpDateRule: "yyyy-MM-dd HH:mm:ss",
    },
    organization: {
      code: "编码",
      type: "类型",
      department: "部门",
      organization: "组织",
      positionType: "岗位类型",
      position: "岗位",
      phone: "固定电话",
      orgCode: "机构编码",
      engName: "英文名称",
      chName: "中文名称",
      selectProvince: "请选择省份",
      selectCity: "请选择城市",
      selectArea: "请选择区县",
      placeDetail: "详细地址",
      selectAddType: "请选择新增类别",
      positionCode: "岗位编码",
      sequence: "顺序号",
      name: "姓名",
      ID: "ID",
      email: "邮箱",
      confirmDelete1: "确认要进行删除操作吗，该操作",
      confirmDelete2: "不可恢复",
      selectResGroup: "请选择要新增的资源分组",
      selectAddorInput: "请选择要新增子组织或岗位并在下方输入名称",
      childOrg: "子组织",
      inputAddOrg: "请输入新增的组织名称",
      inputOrg: "请在此输入组织名称",
      connectedGroup: "已关联资源分组列表",
      resGroupCode: "资源分组编码",
    },
    resource: {
      icon:"图标",
      urlName: "URL名称",
      module: "模块",
      group: "分组",
      menu: "菜单",
      button: "按钮",
      dataAuth: "数据权限",
      urlAuth: "url请求权限",
      resCode: "资源编码",
      onlyCodeRule:
        "唯一资源编码，以字母开头，可以填写数字、字母、下划线（例如：resource_page_1）",
      resName: "资源名称",
      resNameCn: "资源中文名称",
      belongSys: "所属系统",
      resType: "资源类型",
      status: "资源状态",
      resSequence: "顺序号",
      resContent: "资源内容",
      moduleText: "模块说明",
      urlList: "关联url",
      addResTitle: "新增资源",
      editResTitle: "编辑资源",
      area1: "区域一",
      area2: "区域二",
      upload: "上传到服务器",
      uploadRule: "只能上传excel文件",
      exportRes: "导出资源",
    },
    resGroup: {
      connectRes: "关联资源",
      resGroupCode: "资源分组编码",
      resGroupName: "资源分组名称",
      resGroupNameCn: "资源分组中文名称",
      belongSys: "所属系统",
      belongOrg: "所属机构",
      effectiveDate: "生效时间",
      expDate: "失效时间",
      name: "名称",
      addResGroup: "新增资源分组",
      editResGroup: "编辑资源分组",
      onlyConnect: "只能选择一条关联",
    },
  },
  header: {
    switchLang: "切换语言",
    myTable: "我的工作台",
    center: "处理中心",
    logout: "登出",
    mainPage:"主页"
  },
  pages: {},
};
